module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module",
    class: ['is-' + _vm.module.type]
  }, [_c('div', {
    staticClass: "header",
    on: {
      "click": function($event) {
        _vm.expanded = true
      }
    }
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.expanded
    }
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.expanded = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.module.description))]), _vm._v(" "), _c('div', {
    staticClass: "docs"
  }, [(_vm.module.properties.length > 0) ? _c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Static Properties")]), _vm._v(" "), _c('ul', _vm._l((_vm.module.properties), function(property) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.open(property, 'static-method')
        }
      }
    }, [_vm._v(_vm._s(property))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.module.methods.length > 0) ? _c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Static Methods")]), _vm._v(" "), _c('ul', _vm._l((_vm.module.methods), function(method) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.open(method, 'static-method')
        }
      }
    }, [_vm._v(_vm._s(method))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.module.instanceEvents.length > 0) ? _c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Instance Events")]), _vm._v(" "), _c('ul', _vm._l((_vm.module.instanceEvents), function(event) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.open(event, 'event')
        }
      }
    }, [_vm._v(_vm._s(event))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.module.instanceMethods.length > 0) ? _c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Instance Methods")]), _vm._v(" "), _c('ul', _vm._l((_vm.module.instanceMethods), function(method) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.open(method, 'instance-method')
        }
      }
    }, [_vm._v(_vm._s(method))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.module.instanceProperties.length > 0) ? _c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Instance Properites")]), _vm._v(" "), _c('ul', _vm._l((_vm.module.instanceProperties), function(property) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.open(property, 'instance-property')
        }
      }
    }, [_vm._v(_vm._s(property))])
  }))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bg",
    class: {
      'is-active': _vm.expanded
    },
    on: {
      "click": function($event) {
        _vm.expanded = false
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef46ba78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Module.vue
// module id = 51
// module chunks = 1